import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const DescriptionContentContainer = styled.div.attrs({
  id: 'descriptionContentContainer',
})`
  display: flex;
  flex-direction: column;
  position: absolute;
  max-width: ${940 * Screen.widthRatio}px;
`;

export default DescriptionContentContainer;
